// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ihJrQ","fullView":"styles_fullView__2faFR"};